import React from 'react';
import { connect } from 'react-redux';
import { closeSetDateVerificationDialog } from 'store/common/commonActions';
import { setDateVerification } from 'store/reclamation/reclamationsActions';
import SetDateVerificationDialog from './SetDateVerificationDialog';

import { dateToddmmyyy } from 'utils/stringHelper';


class SetDateVerificationDialogContainer extends React.Component {

    constructor(props) {
        super(props);

        // Initialisation du state
        this.state = this.getInitialState();
    }

    getInitialState = () => {
        const initialState = {
            newDate: ''
        };
        return initialState;
    }

    componentDidMount() {
        this.setState(this.getInitialState());
    }


    componentDidUpdate(prevProps) {
        if (prevProps.date !== this.props.date) {
            this.setState({ newDate: dateToddmmyyy(new Date(this.props.date)) });
        }
    }
   


    handleClickSave = () => {

        const { setDateVerification, reclamationId } = this.props;
        const { newDate } = this.state;
        
        setDateVerification(reclamationId, newDate);
        this.props.closeSetDateVerificationDialog();
    }

    handleClickCancel = () => {
        this.props.closeSetDateVerificationDialog();

        this.setState(this.getInitialState());
    }

    handleChange = (event) => {
        const newState = {
            ...this.state,
            [event.target.name]: event.target.value
        };

        this.setState(newState);
    }

    render() {
        const { open, reclamationId, isAdding } = this.props;
        const { newDate } = this.state;

        if (!open) return null;

        return (
            <SetDateVerificationDialog
                onClickSave={this.handleClickSave}
                onClickCancel={this.handleClickCancel}
                reclamationId={reclamationId}
                date={newDate}
                onChange={this.handleChange}
                isAdding={isAdding}
            />
        );
    }
}

const mapStateToProps = state => ({
    open: state.common.setDateVerificationDialogOpen,
    isAdding: state.common.setDateVerificationData.isAdding,
    reclamationId: state.common.setDateVerificationData.reclamationId,
    date: state.common.setDateVerificationData.date
});

const mapDispatchToProps = dispatch => ({
    setDateVerification: (reclamationId, text) => dispatch(setDateVerification(reclamationId, text)),
    closeSetDateVerificationDialog: () => dispatch(closeSetDateVerificationDialog())
});

export default connect(mapStateToProps, mapDispatchToProps)(SetDateVerificationDialogContainer);